
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/combo/[id]",
      function () {
        return require("private-next-pages/combo/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/combo/[id]"])
      });
    }
  